import React from "react";
import "./FraudWarning.css";

export default function FraudWarning() {
  return (
    <section className="fraud-warning">
      <div className="fraud-container">
        <h2>
          BEWARE OF SPURIOUS PHONE CALLS AND FICTITIOUS / FRAUDULENT OFFERS
        </h2>
        <span className="fraud-line"></span>

        <p className="fraud-intro">
          IRDAI clarifies to the public that:
        </p>

        <ul className="fraud-points">
          <li>
            IRDAI or its officials do not involve in activities like sale of any
            kind of insurance or financial products nor invest premiums.
          </li>
          <li>
            IRDAI does not announce any bonus. Public receiving such phone calls
            are requested to lodge a police complaint along with details of the
            phone call, number, etc.
          </li>
        </ul>
      </div>
    </section>
  );
}
